module.exports = __webpack_public_path__ + "static/img/function-box-img2.8e9f337.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unifiedPortal/function-box-img2.png
// module id = d2eE
// module chunks = 0